<template>
     <div>
        <div class="hb-blade-header-wrapper my-4">
            <div class="corporate-title mx-4">Select the user to view / manage ring group membership. If you do not see the user you are looking for, ensure they have the <span class="font-weight-medium pr-1">Take/Make Phone Call</span> permission.</div>
            <v-divider class="mt-4"></v-divider>
        </div>
        <div class="corporate-container my-4 mx-5">
            <!-- <div>
                <HbTextField
                    full
                    search
                    @input="search"
                    v-model="searchUser"
                    maxlength="50"
                    autofocus
                    placeholder="Search User"
                    class="my-1"
                    width="446px"
                />
                </div> -->
            <hb-data-table
                class="mt-4"
                :headers="headers"
                :items="items"
                :loading="userLoading"
            >
            <template v-slot:body="{ items }">
                <tbody>
                    <tr
                    v-for="(item, index) in items"
                    :key="index"
                    :class="{ 'selected-row': selectedRow && selectedRow.user_id === item.user_id }"
                    @click="setHighlightRow(item)"
                    >
                    <td v-for="header in headers" :key="header.value">
                        {{ item[header.value] }}
                    </td>
                    </tr>
                </tbody>
                </template>

            </hb-data-table>
            <ManageRingingGroups v-if="selectedRow"  v-model="showModal"  @close="closeWindow" :selectedUser="selectedRow" />
        </div>
    </div>
</template>

<script>
import api from "../../../assets/api.js";
import { notificationMixin } from "../../../mixins/notificationMixin";
import ManageRingingGroups from "./ManageRingingGroups.vue";
import { mapGetters, mapActions } from 'vuex';
    export default {
        name:"CorporateSettings",
        mixins: [ notificationMixin ],
        components: {
            ManageRingingGroups
        },
        data() {
            return{
                userLoading:false,
                headers: [
                    {
                    text: "User",
                    sortable: false,
                    value: "full_name",
                    class: "table-font-13"
                    }
                ],
                items:[],
                searchUser: null,
                selectedRow: null,
                showModal: false,
                charmProperties:[]
            }
         },
        props: {
            text: {
                type: String,
                default: ""
            },
            selectedVoice:{
                type:String,
                default:"1"
            }
         
        },
         computed: {
        ...mapGetters({
                charmUsers:'charmSubscriptionStore/charmUsers',
                charmSubscribedProperties: "charmSubscriptionStore/charmSubscribedProperties"
            }),
        },
        mounted() {
            this.fetchUsers();
        },
        methods: {
            ...mapActions({
                getCharmUsers:'charmSubscriptionStore/getCharmUsers'
            }),
            async setHighlightRow(row){
                 await api.get(this.$app, api.CHARM_SUBSCRIBED_PROPERTIES_SETTINGS)
                    .then((charm_subscribed_properties) => {
                        this.charmProperties = charm_subscribed_properties?.properties.filter(p => p.mini_charm_enabled === true)
                    })
                    .catch((err) => {
                    console.log(err);
                    })
                const validGdsIds = row?.gds_ids.split(",").filter(gds => this.charmProperties.some(p => p.gds_id === gds)).join(",");
                await this.$store.dispatch('charmSubscriptionStore/getAgentGroups',{user_id: row.user_id});
                if(validGdsIds){
                    this.$store.dispatch('charmSubscriptionStore/getAgentGroupsIvrFlow',{facility_ids: validGdsIds});
                }
                this.selectedRow = row;
                this.showModal = true;
            },
            closeWindow() {
                this.showModal = false;
            },
            search(value) {
                this.searchUser = value;
            },
            async fetchUsers() {
                try {
                    this.userLoading = true;
                    await this.$store.dispatch('charmSubscriptionStore/getCharmUsers');
                    this.items = this.charmUsers;
                } catch (error) {
                    this.showMessageNotification({ type: 'error', description: error });
                } finally {
                    this.userLoading = false;
                }
            }
        },
        watch: {
            showModal(newVal) {
                if (!newVal) {
                    this.selectedRow = null;
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
.selected-row {
  background-color: #E0F5F5;
}
.corporate-title{
    font-weight: 400;
    font-size: 14px;
    line-height: 18px;
    color: #637381;

}
</style>